import React from 'react';
import PropTypes from 'prop-types';

const DisclosureItem = ({keyProp, children}) => (
  <div key={keyProp} className="RoyalBuildYourOrder__body_disclosures_disclosure">
    {children}
  </div>
);

DisclosureItem.propTypes = {
  keyProp: PropTypes.string,
  children: PropTypes.node,
};

export default DisclosureItem;
